import { createContext, useContext } from "react";
import type { AppProviderMode } from "./appProviderMode";

export const AppProviderModeContext = createContext<AppProviderMode>("internal");

export function useAppProviderMode(): AppProviderMode {
  return useContext(AppProviderModeContext);
}
